import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Privacy.css';

const Privacy = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    // Set page title
    document.title = 'Política de Privacidad - Termómetro Emocional';
  }, []);
  
  return (
    <div className="privacy-container">
      <div className="policy-header">
        <h1>Política de Privacidad</h1>
      </div>
      
      <div className="policy-intro">
        <p>En JPsicologo.com nos comprometemos a proteger tu privacidad y tus datos personales. Esta política describe cómo recopilamos, utilizamos y protegemos la información que nos proporcionas al utilizar nuestro servicio.</p>
      </div>
      
      <section className="policy-section">
        <h2>1. Responsable del Tratamiento</h2>
        <div className="section-content">
          <p><strong>Jesús Sagrario - Psicólogo Sanitario</strong></p>
          <p>Número de colegiado: M-32978</p>
          <p>Email de contacto: jesus.sagrario@jpsicologo.com</p>
        </div>
      </section>
      
      <section className="policy-section">
        <h2>2. Datos que Recopilamos</h2>
        <div className="section-content">
          <p>Podemos recopilar los siguientes tipos de información:</p>
          
          <ul className="data-list">
            <li>
              <strong>Datos de identificación:</strong> Nombre y dirección de correo electrónico cuando completas formularios en nuestra plataforma.
            </li>
            <li>
              <strong>Datos de evaluación:</strong> Respuestas proporcionadas en las pruebas de evaluación emocional.
            </li>
            <li>
              <strong>Datos de uso:</strong> Información sobre cómo interactúas con nuestra plataforma, incluyendo páginas visitadas, tiempo de sesión y patrones de navegación.
            </li>
            <li>
              <strong>Datos técnicos:</strong> Dirección IP, tipo de navegador, dispositivo y sistema operativo.
            </li>
          </ul>
        </div>
      </section>
      
      <section className="policy-section">
        <h2>3. Finalidades del Tratamiento</h2>
        <div className="section-content">
          <p>Utilizamos tus datos personales para los siguientes fines:</p>
          
          <table className="purpose-table">
            <thead>
              <tr>
                <th>Categoría de datos</th>
                <th>Finalidad</th>
                <th>Base legal</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Datos de identificación</td>
                <td>Proporcionar recursos personalizados y comunicaciones relacionadas con tu bienestar emocional</td>
                <td>Consentimiento explícito</td>
              </tr>
              <tr>
                <td>Datos de evaluación</td>
                <td>Generar resultados y recomendaciones personalizadas sobre tu bienestar emocional</td>
                <td>Consentimiento explícito</td>
              </tr>
              <tr>
                <td>Datos de uso y técnicos</td>
                <td>Mejorar y optimizar nuestra plataforma y servicios</td>
                <td>Interés legítimo</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
      
      <section className="policy-section">
        <h2>4. Comunicaciones</h2>
        <div className="section-content">
          <p>Si has dado tu consentimiento al marcar la casilla correspondiente, podemos enviarte:</p>
          
          <ul className="communications-list">
            <li>Recursos educativos relacionados con el bienestar emocional</li>
            <li>Información sobre servicios que pueden ser de tu interés</li>
            <li>Actualizaciones sobre nuestros servicios y contenidos</li>
          </ul>
          
          <p>Puedes darte de baja de estas comunicaciones en cualquier momento utilizando el enlace incluido en cada correo electrónico.</p>
        </div>
      </section>
      
      <section className="policy-section">
        <h2>5. Conservación de Datos</h2>
        <div className="section-content">
          <p>Conservaremos tus datos personales durante el tiempo necesario para cumplir con los fines descritos en esta política, a menos que se requiera o permita un período de retención más largo por ley. En concreto:</p>
          
          <ul className="retention-list">
            <li>Los datos de identificación y evaluación se conservarán durante un máximo de 2 años desde tu última interacción con nuestro servicio.</li>
            <li>Los datos de uso se conservarán durante un máximo de 1 año con fines de análisis y mejora.</li>
          </ul>
        </div>
      </section>
      
      <section className="policy-section">
        <h2>6. Tus Derechos</h2>
        <div className="section-content">
          <p>De acuerdo con la normativa de protección de datos, tienes derecho a:</p>
          
          <ul className="rights-list">
            <li>
              <strong>Acceso:</strong> Obtener confirmación sobre si estamos tratando tus datos personales y, en tal caso, acceder a ellos.
            </li>
            <li>
              <strong>Rectificación:</strong> Solicitar la corrección de datos inexactos o incompletos.
            </li>
            <li>
              <strong>Supresión:</strong> Solicitar la eliminación de tus datos personales cuando ya no sean necesarios, entre otros motivos.
            </li>
            <li>
              <strong>Limitación:</strong> Solicitar la limitación del tratamiento de tus datos en determinadas circunstancias.
            </li>
            <li>
              <strong>Portabilidad:</strong> Recibir tus datos en un formato estructurado y transmitirlos a otro responsable.
            </li>
            <li>
              <strong>Oposición:</strong> Oponerte al tratamiento de tus datos para determinados fines.
            </li>
          </ul>
          
          <p>Para ejercer estos derechos, puedes contactarnos a través de nuestra <Link to="/contacto" className="inline-link">página de contacto</Link> o enviando un correo electrónico a privacy@jpsicologo.com.</p>
        </div>
      </section>
      
      <section className="policy-section">
        <h2>7. Compartir Datos con Terceros</h2>
        <div className="section-content">
          <p>No vendemos ni alquilamos tus datos personales a terceros. Sin embargo, podemos compartir tus datos con:</p>
          
          <ul className="sharing-list">
            <li>
              <strong>Proveedores de servicios:</strong> Terceros que nos ayudan a proporcionar y mejorar nuestros servicios (como proveedores de alojamiento web, servicios de email marketing y análisis).
            </li>
            <li>
              <strong>Autoridades competentes:</strong> Cuando sea requerido por ley, decisión judicial o solicitud gubernamental.
            </li>
          </ul>
          
          <p>Todos nuestros proveedores de servicios están obligados a respetar la confidencialidad y seguridad de tus datos personales.</p>
        </div>
      </section>
      
      <section className="policy-section">
        <h2>8. Seguridad de los Datos</h2>
        <div className="section-content">
          <p>Implementamos medidas técnicas y organizativas apropiadas para proteger tus datos personales contra el acceso, la divulgación, la alteración o la destrucción no autorizados, incluyendo:</p>
          
          <ul className="security-list">
            <li>Encriptación de datos sensibles</li>
            <li>Acceso restringido a los datos personales</li>
            <li>Evaluaciones periódicas de seguridad</li>
            <li>Formación del personal en materia de protección de datos</li>
          </ul>
        </div>
      </section>
      
      <section className="policy-section">
        <h2>9. Cookies y Tecnologías Similares</h2>
        <div className="section-content">
          <p>Utilizamos cookies y tecnologías similares para mejorar la experiencia del usuario, analizar el tráfico y personalizar el contenido. Para más información sobre cómo utilizamos las cookies, consulta nuestra <Link to="/cookies" className="inline-link">Política de Cookies</Link>.</p>
        </div>
      </section>
      
      <section className="policy-section">
        <h2>10. Cambios en la Política de Privacidad</h2>
        <div className="section-content">
          <p>Podemos actualizar esta política periódicamente para reflejar cambios en nuestras prácticas de privacidad. Te notificaremos cualquier cambio significativo publicando la nueva política en esta página y, cuando sea apropiado, mediante notificación por correo electrónico.</p>
        </div>
      </section>
      
      <section className="policy-section">
        <h2>11. Contacto y Reclamaciones</h2>
        <div className="section-content">
          <p>Si tienes preguntas o inquietudes sobre nuestra Política de Privacidad o el tratamiento de tus datos, puedes contactarnos a través de nuestra <Link to="/contacto" className="inline-link">página de contacto</Link>.</p>
          
          <p>También tienes derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es) si consideras que el tratamiento de tus datos personales infringe la normativa aplicable.</p>
          
          <p className="last-update">Última actualización: 14 de abril de 2025</p>
        </div>
      </section>
      
      <div className="back-link-container">
        <Link to="/" className="back-link">
          <span className="back-icon">←</span> Volver al inicio
        </Link>
      </div>
    </div>
  );
};

export default Privacy;
